import { render, staticRenderFns } from "./BenefitCardAdd.vue?vue&type=template&id=1968f499"
import script from "./BenefitCardAdd.vue?vue&type=script&lang=js"
export * from "./BenefitCardAdd.vue?vue&type=script&lang=js"
import style0 from "./BenefitCardAdd.vue?vue&type=style&index=0&id=1968f499&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports